import { apiClient } from "../../lib/axios";
import type { MetricsFilters } from "./types";

export interface WeatherTrendPoint {
  label: string; // YYYY-MM-DD
  temperature: number | null;
  humidity: number | null;
  precipitation: number | null;
  sample: number;
}

export interface WeatherTrendsResponse {
  data: { trends: WeatherTrendPoint[] };
}

const buildQueryParams = (params?: MetricsFilters & { uk_region?: string }) => {
  const q: Record<string, unknown> = {};
  if (params?.start_date) q.start_date = params.start_date;
  if (params?.end_date) q.end_date = params.end_date;
  if (params?.region?.length) q.region = params.region;
  if (params?.department?.length) q.department = params.department;
  if (params?.age_range?.length) q.age_range = params.age_range;
  if (params?.sex) q.sex = params.sex;
  if (params?.shift_pattern?.length) q.shift_pattern = params.shift_pattern;
  if (params?.user_ids?.length) q.user_ids = params.user_ids;
  if (params?.client_id) q.client_id = params.client_id;
  if (params?.uk_region) q.uk_region = params.uk_region;
  return q;
};

export type WeatherAnomalyKind =
  | "heatwave"
  | "extreme_heat"
  | "cold_snap"
  | "heavy_precipitation";

export type WeatherAnomalySeverity = "info" | "warning" | "severe";

export interface WeatherAnomaly {
  kind: WeatherAnomalyKind;
  severity: WeatherAnomalySeverity;
  startDay: string; // YYYY-MM-DD
  endDay: string;
  peakValue: number;
  label: string;
  isForecast: boolean;
}

export interface WeatherAnomaliesResponse {
  data: { anomalies: WeatherAnomaly[] };
}

export const weatherApi = {
  getTrends: async (params?: MetricsFilters & { uk_region?: string }): Promise<WeatherTrendsResponse> => {
    const url = params?.client_id
      ? "/admin/client-weather/trends"
      : "/admin/weather/trends";
    const response = await apiClient.get(url, { params: buildQueryParams(params) });
    return response.data;
  },

  getAnomalies: async (
    params?: MetricsFilters & { uk_region?: string },
  ): Promise<WeatherAnomaliesResponse> => {
    const url = params?.client_id
      ? "/admin/client-weather/anomalies"
      : "/admin/weather/anomalies";
    const response = await apiClient.get(url, { params: buildQueryParams(params) });
    return response.data;
  },
};
